import { z } from 'zod';

import { createDateSchemaWithDefinedMinAndMaxBankValues } from '../../../../helpers/zod/createDateSchemaWithDefinedMinAndMaxBankValues';
import { ExtendedOnboardingApplicationStatus } from '../const';

export type OnboardingApplicationsFilterErrorMessages = {
	dateCantBeEarlierThanBankInceptionDateError: string;
	dateMustBeTodayAtLatestError: string;
};

export const getOnboardingApplicationsFilterFormSchema = (
	errorMessages?: OnboardingApplicationsFilterErrorMessages,
) =>
	z.object({
		status: z.enum(ExtendedOnboardingApplicationStatus).nullish(),
		dateCreated: createDateSchemaWithDefinedMinAndMaxBankValues({
			minDateErrorMessage:
				errorMessages?.dateCantBeEarlierThanBankInceptionDateError,
			maxDateErrorMessage: errorMessages?.dateMustBeTodayAtLatestError,
		}),
	});

export const onboardingApplicationsFilterFormSchema =
	getOnboardingApplicationsFilterFormSchema();

export type OnboardingApplicationsFilterData = z.infer<
	typeof onboardingApplicationsFilterFormSchema
>;

export type OnboardingApplicationsFilterForm = z.infer<
	ReturnType<typeof getOnboardingApplicationsFilterFormSchema>
>;
